document.addEventListener('page:loaded', function() {
    // for custom js instead of document ready
        
  });
  document.addEventListener('click', function (event) {

    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('#sizeGuideLink')) return;

    // Don't follow the link
    event.preventDefault();

    // Log the clicked element in the console
    console.log(event.target);

    var sizeGuideModal = new theme.Modals('sizeGuide', 'size-guide-modal');
    sizeGuideModal.open();

}, false);